module.exports = "mutation CancelOrder($id:ID!,$canceledAt:DateTime){cancelCart(cartData:{id:$id,canceledAt:$canceledAt}){cart{id canceledAt}}}"